export const appRoutesConst = {
  index: "/",
  signin: "/signin",

  //packages
  packages: "/packages/:forType",
  packagesDetails: "/packages/:forType/:packageTitle",

  //hotels
  hotels: "/hotels",

  //faqs
  faqs: "/faqs",

  // blogs
  blogs: "/blogs",
  blogDetails: "/blogs/:title",

  //booking
  booking: "/booking",

  // reviews
  reviews: "/reviews",

  // search flight
  searchflight: "/searchflight",

  //imagesGallary
  imagesGallary: "/image-gallery",
  images: "/image-gallery/:id",

  //videosGallary
  videosGallary: "/video-gallery",
  videos: "/video-gallery/:id",

  //contact us
  contactus: "/contactus",

  //privacy policy
  privacypolicy: "/privacy-policy",

  //terms and conditions
  termsandconditions: "/terms-conditions",

  //team
  team: "/team",

  umrahpackages:"/umrah/:slug",

  nusuk:"/nusuk",

  globalTour:"/tour-packages",
  globalTourDetail:'/tour-packages-detail/:slug',
  tenYearVisa:"/10-year-saudi-visa",
  tenYearSaudiTouristEVisa:"/10-year-sauditourist-evisa",
  fiveYearSaudiTouristEVisa:"/5-year-sauditourist-evisa",
  oneYearSaudiTouristEVisa:"/1-year-sauditourist-evisa",
  hajj2025:"/hajj-package",
  // hajj2026:"/hajj-package-2026",
  umrahPackageChicago: "/umrah-package-chicago",
  umrahPackageDallas: "/umrah-package-dallas",
  umrahPackagePhiladelphia: "/umrah-package-philadelphia",
  umrahPackageDearborn: "/umrah-package-dearborn",
  umrahPackageCalifornia: "/umrah-package-california",
  umrahPackageColorado: "/umrah-package-colorado",
  umrahPackageMichigan: "/umrah-package-michigan",
  umrahPackageNewYork: "/umrah-package-newyork",
  umrahPackageHouston: "/umrah-package-houston",
  umrahPackageAtlantaGA: "/umrah-package-atlanta-ga",
  umrahPackagePlanoTX: "/umrah-package-plano-tx",
  umrahPackageOrlandoFL: "/umrah-package-orlando-fl",
  umrahPackageSanDiegoCA: "/umrah-package-san-diego-ca",
  umrahPackageTampaFL: "/umrah-package-tampa-fl",
  umrahPackageMinneapolisMN: "/umrah-package-minneapolis-mn",
  umrahPackageMilwaukeeWI: "/umrah-package-milwaukee-wi",
  umrahPackageLosAngeles: "/umrah-package-los-angeles",
  umrahPackageWashingtonDC: "/umrah-package-washington-dc",
  umrahRamadanPackages: "/umrah-ramadan-packages",
  payment: "/payment",
  januaryUmrahPackage:"/umrah/january-umrah-package",
  februaryUmrahPackage:"/umrah/february-umrah-package",
  julyUmrahPackage:"/umrah/july-umrah-package",
  augustUmrahPackage:"/umrah/august-umrah-package",
  ramadan1stAshraUmrahPackage:"/ramadan-1st-ashra-umrah-package",
  ramadan2ndAshraUmrahPackage:"/ramadan-2nd-ashra-umrah-package",
  ramadan3rdAshraUmrahPackage:"/ramadan-3rd-ashra-umrah-package",
  septemberUmrahPackage:"/umrah/september-umrah-package",
  octoberUmrahPackage:"/umrah/october-umrah-package",
  novemberUmrahPackage:"/umrah/november-umrah-package",
  decemberUmrahPackage:"/umrah/december-umrah-package",
};
